export default "__VITE_ASSET__BDsOCXHL__"